export const rowsPerPageDrodown = [15, 25, 50, 100, 1000, 2000]
export const rowsPerPage = 15
